import { Provider, Injector } from '@angular/core'
import { Apollo, APOLLO_OPTIONS, APOLLO_NAMED_OPTIONS, NamedOptions } from 'apollo-angular'
import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client'
import { GraphQLWsLink } from '@apollo/client/link/subscriptions'
import { createClient } from 'graphql-ws'

import { AuthStorageService } from '@app/services/auth-storage/auth-storage.service'
import {
    createApiAuthErrorLink,
    createApiAuthLink,
    createApiHttpLink,
    createApiLogLink,
    graphQlApiUrl,
} from './graphql.provider.lib'
import { environment } from '@env/environment'

function createApollo(
    auth: AuthStorageService,
    injector: Injector,
): ApolloClient.Options {
    return {
        cache: new InMemoryCache(),
        link: ApolloLink.from([
            createApiAuthErrorLink(injector),
            createApiAuthLink(auth),
            createApiLogLink(),
            createApiHttpLink(environment),
        ]),
    }
}

function createPubsubApollo(): NamedOptions {
    return {
        pubsub: {
            link: new GraphQLWsLink(
                createClient({ url: graphQlApiUrl(environment.pubsub) }),
            ),
            cache: new InMemoryCache(),
        },
    }
}

export function provideGraphQL(): Provider[] {
    return [
        Apollo,
        {
            provide: APOLLO_OPTIONS,
            useFactory: (auth: AuthStorageService, injector: Injector) =>
                createApollo(auth, injector),
            deps: [AuthStorageService, Injector],
        },
        {
            provide: APOLLO_NAMED_OPTIONS,
            useFactory: createPubsubApollo,
            deps: [],
        },
    ]
}
